import {getNewOutlet} from 'reconnect.js';
/*  __CODEGEN_START__ */ 

/* __CODEGEN_END__  */

getNewOutlet('extra', {}, {autoDelete: false});
/*  __CODEGEN_START__ */ 

/* __CODEGEN_END__  */
